export default __webpack_public_path__ + "static/hansahogar-ea35c452808bdd1b5f894ef4f67e7800.png";